import { HStack, Icon, StackProps, Text, VStack } from "@chakra-ui/react";
import { RiArrowLeftLine } from "@remixicon/react";

interface Props extends StackProps {
  isSubPage?: boolean;
  title: string;
  subtitle?: string;
  onClick?: () => void | undefined;
}

export const TitlePageDashboard = ({
  isSubPage = false,
  title,
  subtitle,
  onClick,
  ...rest
}: Props) => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <VStack py={2} gap={0} align={"stretch"} {...rest}>
      <HStack>
        {isSubPage && (
          <Icon
            as={RiArrowLeftLine}
            cursor={"pointer"}
            onClick={onClick ? onClick : handleBack}
          />
        )}
        <Text textStyle={"h-reg-title"}>{title}</Text>
      </HStack>

      {subtitle && (
        <Text textStyle={"b-reg"} variant={"secondary"} ml={6}>
          {subtitle}
        </Text>
      )}
    </VStack>
  );
};
